import CIMMeasurementRegistersPage from './CIMMeasurementRegistersPage';

export default CIMMeasurementRegistersPage;
